import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-login',
  templateUrl: './footer-login.component.html',
  styleUrls: ['./footer-login.component.scss']
})
export class FooterLoginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
